import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { map, find as rFind, propEq } from 'ramda';

import { RadioButton, RadioButtonGroup as MaterialRadioButtonGroup } from 'material-ui/RadioButton';

import { edit, view, radio } from './RadioButtonGroup.less';

const presets = {
  yesno: [
    { value: 'yes', label: 'dictionary.yes' },
    { value: 'no', label: 'dictionary.no' },
  ],
  yesnounknown: [
    { value: 'yes', label: 'dictionary.yes' },
    { value: 'no', label: 'dictionary.no' },
    { value: 'unknown', label: 'dictionary.unknown' },
  ],
};

const Edit = ({ input, meta, optionFormatter, localeMessage, options, preset, formatMessage, disabled }) => (
  <MaterialRadioButtonGroup
    className={edit}
    name={input.name}
    onChange={(e, val) => input.onChange(val)}
    valueSelected={input.value}
  >
    {map(option => (
      <RadioButton
        key={`${input.name}__${option.value}`}
        className={radio}
        value={option.value}
        label={
          (option.label && formatMessage({ id: option.label })) ||
          localeMessage(optionFormatter ? optionFormatter(option.value) : option.value)
        }
        disabled={disabled}
      />
    ))((preset && presets[preset]) || options)}
  </MaterialRadioButtonGroup>
);

const View = ({ input, optionFormatter, formatMessage, preset, options, localeMessage }) => {
  const selectedOption = rFind(propEq('value', input.value))((preset && presets[preset]) || options);
  if (!selectedOption) {
    return null;
  }

  return (
    <div className={view}>
      {selectedOption.label
        ? formatMessage({ id: selectedOption.label })
        : localeMessage(optionFormatter ? optionFormatter(selectedOption.value) : selectedOption.value)}
    </div>
  );
};

class RadioButtonGroup extends Component {
  render() {
    const {
      editing,
      intl: { formatMessage },
      ...other
    } = this.props;

    return editing ? (
      <Edit formatMessage={formatMessage} {...other} />
    ) : (
      <View formatMessage={formatMessage} {...other} />
    );
  }
}

View.propTypes = {
  input: PropTypes.object,
  formatMessage: PropTypes.func,
  preset: PropTypes.string,
  options: PropTypes.array,
  localeMessage: PropTypes.func, // Takes a localization id and returns the message
  optionFormatter: PropTypes.func, // Takes the localization id and manipulates it, usable for namespacing
};

Edit.propTypes = {
  input: PropTypes.object,
  formatMessage: PropTypes.func,
  localeMessage: PropTypes.func, // Takes a localization id and returns the message
  optionFormatter: PropTypes.func, // Takes the localization id and manipulates it, usable for namespacing
  meta: PropTypes.object,
  options: PropTypes.array, // eslint-disable-line,
  preset: PropTypes.string,
  disabled: PropTypes.bool,
};

RadioButtonGroup.propTypes = {
  editing: PropTypes.bool,
  intl: intlShape,
};

export default injectIntl(RadioButtonGroup);
